import { render, staticRenderFns } from "./LivePreview.vue?vue&type=template&id=ddac87d8&scoped=true&"
import script from "./LivePreview.vue?vue&type=script&lang=ts&"
export * from "./LivePreview.vue?vue&type=script&lang=ts&"
import style0 from "./LivePreview.vue?vue&type=style&index=0&id=ddac87d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac87d8",
  null
  
)

export default component.exports